import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errText } from "../../../lib/api";
import { PolicyRow, NewPolicyForm } from "./PolicyRows";

export const PoliciesSection = () => {
  const [policies, setPolicies] = useState([]);
  const [newPolicy, setNewPolicy] = useState({ leave_type: "", name: "", annual_quota: 10 });

  const load = useCallback(() => api.get("/leave/policies").then((r) => setPolicies(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const savePolicy = async (p) => {
    try {
      await api.post("/leave/policies", { leave_type: p.leave_type, name: p.name, annual_quota: +p.annual_quota });
      toast.success(`${p.name} updated`);
      load();
    } catch (e) { toast.error(errText(e)); }
  };

  const addPolicy = async (e) => {
    e.preventDefault();
    try {
      await api.post("/leave/policies", { ...newPolicy, leave_type: newPolicy.leave_type.toUpperCase(), annual_quota: +newPolicy.annual_quota });
      toast.success("Leave policy added");
      setNewPolicy({ leave_type: "", name: "", annual_quota: 10 });
      load();
    } catch (err) { toast.error(errText(err)); }
  };

  const delPolicy = async (lt) => {
    await api.delete(`/leave/policies/${lt}`);
    toast.success("Policy removed");
    load();
  };

  return (
    <section className="bg-white border border-stone-200 rounded-lg p-6 space-y-4">
      <h3 className="font-heading font-bold">Leave policies</h3>
      <div className="space-y-3">
        {policies.map((p, i) => (
          <PolicyRow key={p.leave_type} policy={p}
            onQuotaChange={(v) => setPolicies(policies.map((x, j) => (j === i ? { ...x, annual_quota: v } : x)))}
            onSave={() => savePolicy(p)} onDelete={() => delPolicy(p.leave_type)} />
        ))}
      </div>
      <NewPolicyForm value={newPolicy} onChange={setNewPolicy} onSubmit={addPolicy} />
    </section>
  );
};
